import React from 'react'
import { CreateSupportAnnounce10EstimateContainer } from '../../containers/Officer/CreateSupportAnnounce10EstimateContainer'
export const CreateSupportAnnounce10EstimatePage = () => {
    return (
        <CreateSupportAnnounce10EstimateContainer />
    )
}
